import React from 'react'

const DocForm = () => {
  return (
    <div>DocForm</div>
  )
}

export default DocForm